import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { VendorService } from '../../../services/vendor.service';
import { Vendor } from '../../../models/vendor.model';
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/user.model';

@Component({
  selector: 'app-delete-user-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatProgressBarModule,
    CommonModule,
    MatButtonModule,
  ],
  templateUrl: './delete-user-dialog.component.html',
  styleUrl: './delete-user-dialog.component.scss'
})
export class DeleteUserDialogComponent {
  loading: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<DeleteUserDialogComponent>,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: { userId: string }
  ) {}

  user?: User;

  get role() {
    return this.user?.userRoles[0].role.name ?? 'User'
  }

  ngOnInit() {
    this.userService.getSingle(this.data.userId).subscribe(user => this.user = user);
  }

  onDelete() {
    this.loading = true;

    let updatedUser: User = {
      ...this.user!,
      ...{
        status: 'DELETED'
      }
    };

    this.userService.update(updatedUser).subscribe({
      next: () => {
        this.loading = false;
        this.dialogRef.close();
      },
      error: () => {
        this.loading = false;
        this.dialogRef.close({
          message: 'User could not be deleted. Please try again.',
        });
      },
    });
  }

  onCancel() {
    this.dialogRef.close();
  }
}
